/**
 * ToolTimeline — renders the tool-call steps for an assistant message
 * produced by the new agent SSE flow.
 *
 * No-op for messages from the legacy endpoint (which never set `steps`).
 */

import React from "react";

import "./ToolTimeline.css";

const STATUS_LABEL = {
  running: "Running…",
  ok: "Done",
  error: "Failed",
};

function shortArgs(raw) {
  if (!raw) return "";
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    return JSON.stringify(parsed, null, 2);
  } catch (_e) {
    return String(raw);
  }
}

const ToolTimeline = ({ steps }) => {
  if (!steps || steps.length === 0) return null;

  // Hide the timeline once there are no tool calls at all (final-text-only
  // runs shouldn't render an empty section).
  const anyToolCalls = steps.some(
    (s) => Array.isArray(s.toolCalls) && s.toolCalls.length > 0,
  );
  if (!anyToolCalls) return null;

  return (
    <div className="tool-timeline">
      {steps.map((step) =>
        (step.toolCalls || []).map((tc) => (
          <div
            key={tc.id}
            className={`tool-timeline__item tool-timeline__item--${tc.status || "pending"}`}
          >
            <div className="tool-timeline__header">
              <span className="tool-timeline__name" title={tc.name}>
                {tc.title}
              </span>
              <span className="tool-timeline__status">
                {STATUS_LABEL[tc.status] ?? tc.status}
                {typeof tc.latencyMs === "number"
                  ? ` · ${tc.latencyMs}ms`
                  : ""}
              </span>
            </div>
            {tc.arguments && (
              <pre className="tool-timeline__args">{shortArgs(tc.arguments)}</pre>
            )}
            {tc.error && (
              <div className="tool-timeline__error">
                {tc.error.type ? `${tc.error.type}: ` : ""}
                {tc.error.message || "Tool failed"}
              </div>
            )}
          </div>
        )),
      )}
    </div>
  );
};

export default ToolTimeline;
